import React, {useState} from "react";
import {Box, Button, Typography} from "@mui/material";
import "../App.css";
import { useNavigate } from "react-router-dom";
import MissionSelection from "../components/mission_selection";

const Missions = () => {

    const [selectedMissionId, setSelectedMissionId] = useState(null);
    const navigate = useNavigate();

    const onClickStats = () => {
        navigate(`/stats`);
    }

    const onClickNextGroup = () => {
        if (selectedMissionId != null) {
            navigate(`/groups?missionId=${selectedMissionId}`);
        }
    }

    const onClickNextProperty = () => {
        if (selectedMissionId != null) {
            navigate(`/property?missionId=${selectedMissionId}`);
        }
    }

    const onMissionSelectCallBack = (missionId) => {
        setSelectedMissionId(missionId);
    }

    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" , padding:5}}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                    width: "100%",
                    textAlign: "center",
                }}
            >
                <Button name={"stats"} variant="outlined" onClick={onClickStats} >Statistiques</Button>
                <Typography variant="h4"> Sélection de la mission</Typography>
                <Button name={"next"} variant="outlined" onClick={onClickNextProperty} disabled={selectedMissionId == null}> Sélection par propriétés</Button>
                <Button name={"next"} variant="outlined" onClick={onClickNextGroup} disabled={selectedMissionId == null}> Sélection par groupe</Button>
            </Box>
            <Box
                sx={{
                    width: "100%",
                    textAlign: "center",
                    maxHeight:"90vh"
                }}
            >
                <MissionSelection onMissionSelectCallBack={onMissionSelectCallBack}/>
            </Box>
        </Box>
    );
}

export default Missions;
